import SEOHead from "@/components/SEOHead";

// Shared wrapper for static legal/compliance pages. Presentation only — no app logic.
export default function LegalPageLayout({ title, description, updated, testid, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid={testid}>
      <SEOHead title={title} description={description} />
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{title}</h1>
      {updated && <p className="mt-2 text-sm text-slate-400">Last updated: {updated}</p>}
      <div className="mt-8 space-y-3 text-slate-600 [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-8 [&_h2]:mb-1 [&_p]:text-sm [&_p]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_li]:text-sm">
        {children}
      </div>
    </div>
  );
}
